import { useEffect } from 'react';
import { useSession } from '@/session/useSession';
import { useHubTheme } from './ThemeContext';

/**
 * Bridges the session lifecycle to the theme provider ABOVE it: the theme endpoint is
 * session-scoped, so the fetch fires exactly once, on the first active session. Renders nothing.
 */
export function ThemeFetcher() {
  const { status } = useSession();
  const { load } = useHubTheme();

  useEffect(() => {
    if (status === 'active') load();
  }, [status, load]);

  return null;
}
